import { Graphics } from 'pixi.js';
import type { AmmoComponent } from '@game/scenes/characterPrototype/types';
import { clamp } from '@game/scenes/characterPrototype/math';

export function updateAmmoBarGraphic(graphic: Graphics, ammo: AmmoComponent, fill: number, stroke: number, ownerSize: number) {
	const capacity = Math.max(1, Math.round(ammo.capacity));
	const remaining = clamp(Math.round(ammo.remaining), 0, capacity);
	const barWidth = Math.max(24, ownerSize * 0.95);
	const barHeight = 6;
	const gap = 2;
	const segW = Math.max(2, (barWidth - gap * (capacity - 1)) / capacity);
	const left = -barWidth / 2;
	const top = -barHeight / 2;

	graphic.clear();

	for (let i = 0; i < capacity; i += 1) {
		const x = left + i * (segW + gap);
		graphic.roundRect(x, top, segW, barHeight, 2);
		graphic.fill({ color: fill, alpha: i < remaining ? 0.9 : 0.18 });
	}
	graphic.roundRect(left - 1, top - 1, barWidth + 2, barHeight + 2, 3);
	graphic.stroke({ color: stroke, alpha: 0.55, width: 1 });

	if (ammo.reloadRemaining > 0) {
		const d = Math.max(0.05, ammo.reloadDuration);
		const t = clamp(1 - ammo.reloadRemaining / d, 0, 1);
		const w = barWidth * t;
		const y = top + barHeight + 4;
		graphic.roundRect(left, y, barWidth, 3, 2);
		graphic.fill({ color: 0x94a3b8, alpha: 0.25 });
		graphic.roundRect(left, y, w, 3, 2);
		graphic.fill({ color: fill, alpha: 0.55 });
	}
}


